import { NAV_STATE_KEY, USER_DATA_KEY } from './../../../shared/constants/app.constants';
import { Component, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, NavigationError, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StorageService } from '../../services/general-utils';
import { Utente } from '../../models/general/utente';
import { AccountService } from '../../services/rest/account.service';
import { UserService } from '../../services/rest/user.service';
import { NavItem } from '../../models/general/nav-item';
import { OuNavInfo } from '../../models/sidebar/ou-nav-info';
import { SheetNavInfo } from '../../models/sidebar/sheet-nav-info';
import { GroupNavInfo } from '../../models/sidebar/group-nav-info';
import { environment } from 'src/environments/environment';
import { CambiService } from '../../services/rest/cambi.service';

@Component({
  selector: 'advisor24-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  private renderer: Renderer2;
  ouItems: OuNavInfo[];
  accountStatus$: Observable<Utente | null>;

  imgUrl: string;
  urlLoaded: boolean;
  ticket: string;
  userDataKey: any;
  cambi: string;

  constructor(
    public accountService: AccountService,
    private titleService: Title,
    private router: Router,
    private translateService: TranslateService,
    public storageService: StorageService,
    private rootRenderer: RendererFactory2,
    public deviceDetector: DeviceDetectorService,
    private userService: UserService,
    private cambiService: CambiService
  ) {
    this.renderer = rootRenderer.createRenderer(document.querySelector('html'), null);
  }

  ngOnInit(): void {
    // try to log in automatically
    this.accountStatus$ = this.accountService.identity();
    this.accountStatus$.subscribe(account => {
      if (!account) {
        console.log('[MainComponent] - account NOT found!');
        this.router.navigate(['/login']);
      }
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationError && event.error.status === 404) {
        this.router.navigate(['/404']);
      }
    });

    this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.renderer.setAttribute(document.querySelector('html'), 'lang', langChangeEvent.lang);
    });
    this.getCambi();
    this.setCambiInterval();
    this.ouItems = this.storageService.hasItem(NAV_STATE_KEY) ? JSON.parse(this.storageService.getItem(NAV_STATE_KEY)) : this.getNavItems();
    // this.navItems = this.accountService.filterNavItems(this.navItems);
    this.userDataKey = JSON.parse(this.storageService.getItem(USER_DATA_KEY));
    this.getCookie();
  }

  closeSidebar() {
    document.getElementById('sidebar').classList.remove('active');
    document.getElementById('blockScreen').classList.remove('active');
  }

  setCambiInterval() {
    setInterval(() => {
      this.getCambi();
    }, (environment.reload_cambi_interval * 1000));
  }

  getCambi() {
    this.cambiService.getCambi().subscribe({
      next: respGetCambi => {
        let tmpCambi = "";
        respGetCambi.forEach(cambio => {
          tmpCambi += cambio.currency + ' ' + Number(cambio.rate).toLocaleString('it-IT', {minimumFractionDigits: 5}) + '\xa0\xa0\xa0\xa0\xa0\xa0'; 
        });
        this.cambi = tmpCambi;
      },
      error: error => {
        console.log('ERROR ' + error.status + ': ' + error.statusText + ', caused by an http request.');
      }
    });
  }

  // La sidebar viene costruita dinamicamente in base alle app a cui l'utente è autenticato su LDAP (ogni app ha un proprio id che serve per 
  // effettuare il mashup di qlik, con l'eccezione di alcune, es. Simulativo, Pricing ecc... che sono pagine integrate in questa app Angular)
  getNavItems() {
    let apps = JSON.parse(this.storageService.getItem(USER_DATA_KEY)).qlikIds.apps; // Recupero lista app da local storage
    apps = apps.sort((a, b) => Number(a.order) - Number(b.order)); // Ordinamento della lista

    let ouItems: OuNavInfo[] = [];
    let tmpDescription: string = '';
    let ouIndex: number = 0;
    let appIndex: number = 0;

    let tmpOu = null;
    ouItems.push({
      index: ouIndex,
      title: null,
      isOpen: false,
      apps: []
    });
    apps.forEach(app => {

      const sheetRoutes: SheetNavInfo[] = [];
      const groupRoutes: GroupNavInfo[] = [];
      let groupIndex = 0;
      if (app.sheets) {
        app.sheets.forEach(sheet => {

          if (sheet.description === '') {
            sheetRoutes.push({
              path: '/qlik-mashup',
              title: sheet.name,
              appId: app.appId,
              sheetId: sheet.id,
              icon: 'fas fa-chart-bar',
              iconValue: '',
              active: false
            });
          } else {
            if (sheet.description !== tmpDescription) {
              tmpDescription = sheet.description;
              groupRoutes.push({
                index: groupIndex,
                title: tmpDescription,
                isOpen: false,
                sheets: [{
                  path: '/qlik-mashup',
                  title: sheet.name,
                  appId: app.appId,
                  sheetId: sheet.id,
                  icon: 'fas fa-chart-bar',
                  iconValue: '',
                  active: false
                }]
              });
              groupIndex++;
            } else {
              groupRoutes[groupRoutes.length - 1].sheets.push({
                path: '/qlik-mashup',
                title: sheet.name,
                appId: app.appId,
                sheetId: sheet.id,
                icon: 'fas fa-chart-bar',
                iconValue: '',
                active: false
              });
            }
          }

        });
      }

      if (app.ouName === tmpOu) {
        ouItems[ouIndex].apps.push({
          index: appIndex,
          title: app.appName,
          appId: app.appId,
          isOpen: false,
          sheets: sheetRoutes.filter((menuItem) => menuItem),
          groups: groupRoutes
        });
        appIndex++;
      } else {
        ouIndex++;
        tmpOu = app.ouName;
        appIndex = 0;
        ouItems.push({
          index: ouIndex,
          title: app.ouName,
          isOpen: false,
          apps: [{
            index: appIndex,
            title: app.appName,
            appId: app.appId,
            isOpen: false,
            sheets: sheetRoutes.filter((menuItem) => menuItem),
            groups: groupRoutes
          }]
        });
        appIndex++;
      }
    });

    this.storageService.setItem(NAV_STATE_KEY, JSON.stringify(ouItems));
    return ouItems;
  }

  getCookie() {
    this.ticket = this.userDataKey.qlikIds.ticket;
    this.imgUrl = "https://" + environment.qlik_host + ":" + environment.qlik_port + "/resources/img/core/dark_noise_16x16.png?qlikTicket=" + this.ticket;
    this.urlLoaded = true;
  }

  loadQlikObjects() {
    // aggiungo iframe fittizi per mantenimento filtri al cambio pagina
    // this.userDataKey.qlikIds.apps.forEach(app => {
    //   if (app.sheets && app.sheets.length > 0) {
    //     let element = document.createElement("iframe");
    //     const appId = app.appId;
    //     const sheetId = app.sheets[0].id;
    //     element.setAttribute("src", "https://" + environment.qlik_host + "/single/?appid=" + appId +
    //       "&sheet=" + sheetId + "&opt=ctxmenu,currsel");
    //     element.style.width = "0px";
    //     element.style.height = "0px";
    //     element.hidden = true;
    //     document.getElementById("main-content").appendChild(element);
    //   }
    // });
  }

}
